module.exports = __webpack_public_path__ + "media/images/flags/sk-878eea621a167b85e70659b77ef9cc89.svg";